__webpack_require__.p = "https://www.cards.dev.hallmark.co.uk/";